import type { Plan } from 'src/types';

const PRO_PLAN_INTERVAL = 'year';

type BuildUpgradeUrlOpts = {
  upgradePlanId?: number;
};
export const buildUpgradeUrl = (opts: BuildUpgradeUrlOpts) => {
  const url = opts.upgradePlanId
    ? `/app/planbuilder/checkout?planId=${opts.upgradePlanId}`
    : '/app/planbuilder/plans';
  return encodeURI(url);
};

export const getProfessionalPlanData = (
  possiblePlans: Array<{
    planType: string;
    plans: Array<Plan>;
  }>
) => {
  const professionalPlans =
    possiblePlans.filter((plan) => plan.planType === 'Professional')?.[0]
      ?.plans ?? [];

  const professionalPlansSortedByIncludedTasks = [...professionalPlans].sort(
    ({ includedTasksPerMonth: a }, { includedTasksPerMonth: b }) => a - b
  );

  const professionalPlan = professionalPlansSortedByIncludedTasks?.find(
    (plan) => plan.interval === PRO_PLAN_INTERVAL
  );

  const professionalUpgradeUrl = buildUpgradeUrl({
    upgradePlanId: professionalPlan?.id,
  });

  // Divide by 12 since `nextPlan` is always annual.
  const professionalPlanAmount = (professionalPlan?.amount || 0) / 12;

  return { professionalUpgradeUrl, professionalPlanAmount };
};
